import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default, { useState, useCallback } from 'react';
import { Paginator } from './Paginator.es.js';

const PaginatorStateful = (_a) => {
  var { initialPageIndex = 0, onPaginate } = _a, props = __rest(_a, ["initialPageIndex", "onPaginate"]);
  const [currentPageIndex, setCurrentPageIndex] = useState(initialPageIndex);
  const onPaginateStateful = useCallback((data, event) => {
    setCurrentPageIndex(data.pageIndex);
    if (onPaginate) {
      onPaginate(data, event);
    }
  }, [onPaginate]);
  return React__default.createElement(Paginator, Object.assign({}, props, { currentPageIndex, onPaginate: onPaginateStateful }));
};

export { PaginatorStateful };
//# sourceMappingURL=PaginatorStateful.es.js.map
